import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

const states = {
  INVALID: {
    class: 'error',
    label: <Translate value={'dossier.state.INVALID.fullLabel'}/>
  },
  DEPOSITOR_SERVICE_DEACTIVATED: {
    class: 'error',
    label: <Translate value={'dossier.state.DEPOSITOR_SERVICE_DEACTIVATED.fullLabel'}/>
  },
  WARNING: {
    class: 'warning',
    label: <Translate value={'dossier.state.WARNING.fullLabel'}/>
  },
  VALID: {
    class: 'success',
    label: <Translate value={'dossier.state.VALID.fullLabel'}/>
  },
  UNKNOWN: {
    class: 'information',
    label: <Translate value={'dossier.state.UNKNOWN.fullLabel'}/>
  },
  AWAITING_VERIFICATION: {
    class: 'ofa',
    label: <Translate value={'dossier.state.AWAITING_VERIFICATION.fullLabel'}/>
  }
};

class DossierState extends Component {
  render() {
    if (this.props.state === 'NULL' || this.props.state === 'EMPTY') {
      return (<div/>);
    }

    const state = states[this.props.state];
    const icon = state ?
      this.renderChip(state) :
      (<Icon icon="loader"/>);

    return (
      <span>
        {icon}
      </span>);
  }

  renderChip(state) {
    const className = `${this.props.important ? 'chip-l' : 'chip'} no-wrap ${state.class}`;
    if (this.props.onClick) {
      return (
        <button
          type="button"
          className={className}
          onClick={this.props.onClick}
        >
          {state.label}
        </button>
      );
    }

    return (
      <span className={className}>
        {state.label}
      </span>
    );
  }
}

DossierState.defaultProps = {
  important: false
};

DossierState.propTypes = {
  state: PropTypes.string,
  important: PropTypes.bool,
  onClick: PropTypes.func
};

export default DossierState;
